module.exports = {
	data() {
		return {
			showingPlanFeatures: false,
		}
	},        

	watch: {
		/**
         * Show the plan details for the given plan.
         */
        detailingPlan(plan) {
        	if(plan) {
	            this.showingPlanFeatures = true;
	        }
        }
    }
}
